import React from 'react';

interface IActionButtonProps {
  isLoading: boolean;
  handleActionButton: () => void;
  actionButtonImage: string;
  actionButtonTitle: string;
  actionButtonText: string;
}

export const AttachFileAction: React.FC<IActionButtonProps> = ({
  actionButtonImage,
  actionButtonText,
  actionButtonTitle,
  isLoading,
  handleActionButton,
}) => (
  <div
    className={`flex flex-col w-[15rem] py-6  h-[17rem]  gap-8 border border-gray-700 rounded shadow-md hover:shadow-xl ${
      isLoading ? 'animate-pulse grayscale opacity-30 pointer-events-none' : 'pointer-events-auto'
    }`}
    onClick={handleActionButton}
  >
    <img className="self-center aspect-auto w-14" src={actionButtonImage} alt=""></img>
    <div className="flex flex-col gap-2">
      <p className="  text-center text-xl text-purple">{actionButtonTitle}</p>
      <p className="justify  mx-auto text-center text-sm text-secondary_text">{actionButtonText}</p>
    </div>
  </div>
);
